import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const PatientManagementIconActive: React.FC<SvgIconProps> = () => {
  return (
    <SvgIcon
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="6" fill="#13A9BA" />
      <path
        d="M14 4C19.52 4 24 8.48 24 14C24 19.52 19.52 24 14 24C8.48 24 4 19.52 4 14C4 8.48 8.48 4 14 4ZM11.7402 8.30957C10.6902 10.8696 8.6 12.8804 6 13.8604C6.00986 13.9003 6 13.9501 6 14C6 18.41 9.59 22 14 22C18.41 22 22 18.41 22 14C22 13.22 21.8799 12.4698 21.6699 11.7598C20.9699 11.9098 20.25 12 19.5 12C16.37 12 13.5802 10.5596 11.7402 8.30957ZM11 13.75C11.69 13.75 12.25 14.31 12.25 15C12.25 15.69 11.69 16.25 11 16.25C10.31 16.25 9.75 15.69 9.75 15C9.75 14.31 10.31 13.75 11 13.75ZM17 13.75C17.69 13.75 18.25 14.31 18.25 15C18.25 15.69 17.69 16.25 17 16.25C16.31 16.25 15.75 15.69 15.75 15C15.75 14.31 16.31 13.75 17 13.75ZM10.0801 7.03027C8.37017 8.00024 7.04994 9.57985 6.41992 11.4697C8.12983 10.4998 9.45006 8.92015 10.0801 7.03027ZM14 6C13.54 6 13.0901 6.05013 12.6602 6.12012C14.0602 8.44003 16.6001 10 19.5 10C19.96 10 20.4099 9.94987 20.8398 9.87988C19.4398 7.55997 16.8999 6 14 6Z"
        fill="white"
        fillOpacity="0.96"
      />
    </SvgIcon>
  );
};

export default PatientManagementIconActive;
